import UserRole from '../enums/UserRole';
import CareTicket from '../models/CareTicket';
import Message from '../models/Message';
import { db } from './MytChatDB';

export default class TicketDBOps {
  static shared = new TicketDBOps();

  private constructor() {}

  upsertTicket = async (ticket: CareTicket) => {
    await db.ticket.put(ticket);
  };

  deleteTicket = async (userId: string) => {
    await db.ticket.delete(userId);
  };

  clearUnread = async (userId: string) => {
    try {
      await db.ticket.update(userId, { unread: 0 });
    } catch (e) {
      // ignore
    }
  };

  incrementUnread = async (message: Message) => {
    try {
      const ticket = await db.ticket.get(message.from);
      // console.log('[TicketDBOps] incrementUnread', { message.from, ticket });
      if (ticket) {
        const newUnread = (ticket.unread || 0) + 1;
        await db.ticket.update(message.from, {
          unread: newUnread,
          timestamp: message.timestamp,
          message: message
        });
      }
    } catch (e) {
      // ignore
    }
  };

  saveTickets = async (role: UserRole, tickets: CareTicket[]) => {
    const nextUsers = new Set(tickets.map((ticket) => ticket.user).filter(Boolean));

    await db.transaction('rw', db.ticket, async () => {
      const existingTicketsForRole = await db.ticket.where('role').equals(role).toArray();
      const usersToDelete = existingTicketsForRole
        .filter((ticket) => !nextUsers.has(ticket.user))
        .map((ticket) => ticket.user);

      if (usersToDelete.length > 0) {
        await db.ticket.bulkDelete(usersToDelete);
      }

      if (tickets.length > 0) {
        await db.ticket.bulkPut(tickets);
      }
    });
  };

  getAllTickets = async () => {
    return db.ticket.toArray();
  };
}
